(function () {
  'use strict';
  /* jp-comucare-sticky 2026-08-21 */

  /* ------------------------------------------------------------------
     「加入购物车」按钮：AJAX 加购并打开主题原生购物车抽屉。
     忠实复刻 theme.js 里 ProductForm 的事件流（cart:prepare-bundled-sections
     → cart/add.js(带 sections) → cart.js → variant:add + cart:change），
     由 <cart-drawer> 自己 .show()/刷新，不手动改 open 属性。
     ------------------------------------------------------------------ */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartType() {
    return (
      (window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.cartType) ||
      'drawer'
    );
  }

  function selectedCareVariantId() {
    var checked = document.querySelector('[data-comu-care-option]:checked');
    return checked ? checked.dataset.variantId : null;
  }

  function collectProductFormProperties() {
    var form =
      document.querySelector('.product-info__buy-buttons form[is="product-form"]') ||
      document.querySelector('form[is="product-form"]');
    var properties = {};
    if (!form) return properties;
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.name.indexOf('properties[') !== 0) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      properties[el.name.slice('properties['.length, -1)] = el.value;
    });
    return properties;
  }

  function parseCartAddResponse(response) {
    return response.text().then(function (raw) {
      var json = null;
      try {
        json = JSON.parse(raw);
      } catch (parseError) {
        json = { description: raw.replace(/\s+/g, ' ').slice(0, 120) };
      }
      return { ok: response.ok, json: json };
    });
  }

  function addToCartAndReveal(variantId, quantity) {
    var root = cartRoot();
    var careId = selectedCareVariantId();
    var qty = quantity || 1;

    // 让 <cart-drawer> 把自身 section id 推入待返回列表（与 ProductForm 一致）
    var bundledSections = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: bundledSections }
      })
    );

    var request;
    if (careId) {
      // 与购买区 submitWithCare 同一条已复测成功的 items[]：主机+延保一次写入。
      request = fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [
            { id: Number(variantId), quantity: qty, properties: collectProductFormProperties() },
            { id: Number(careId), quantity: qty, properties: { _comucare_for: String(variantId) } }
          ],
          sections: bundledSections.join(','),
          sections_url: root + 'variants/' + variantId
        })
      });
    } else {
      var formData = new FormData();
      formData.set('id', variantId);
      formData.set('quantity', qty);
      formData.set('sections', bundledSections.join(','));
      formData.set('sections_url', root + 'variants/' + variantId);
      request = fetch(root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    }

    return request
      .then(parseCartAddResponse)
      .then(function (result) {
        if (!result.ok) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          throw new Error((result.json && (result.json.description || result.json.message)) || 'cart add failed');
        }
        return result;
      })
      .then(function (result) {
        if (cartType() === 'page') {
          window.location.href = root + 'cart';
          return;
        }

        return fetch(root + 'cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            cart.sections = result.json.sections;
            var items = result.json.items || [result.json];

            /* variant:add 触发抽屉 .show()（drawer 模式）或加购通知（popover 模式） */
            document.documentElement.dispatchEvent(
              new CustomEvent('variant:add', {
                bubbles: true,
                detail: { items: items, cart: cart }
              })
            );
            /* cart:change 刷新抽屉内容 */
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', cart: cart }
              })
            );
          });
      });
  }

  function bindStickyAddToCart() {
    if (window.__comuStickyAddBound) return;
    window.__comuStickyAddBound = true;

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-comu-sticky-add]');
      if (!btn) return;

      event.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;

      var variantId = btn.getAttribute('data-variant-id');
      var quantity = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
      var fallbackHref = btn.getAttribute('href');

      if (!variantId) {
        if (fallbackHref) window.location.href = fallbackHref;
        return;
      }

      btn.setAttribute('aria-busy', 'true');
      addToCartAndReveal(variantId, quantity)
        .then(function () {
          btn.removeAttribute('aria-busy');
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          if (fallbackHref) window.location.href = fallbackHref;
        });
    });
  }

  var drawerSyncCallbacks = [];
  var drawerSyncReady = false;

  function initDrawerSync(onChange) {
    drawerSyncCallbacks.push(onChange);

    function notify(isOpen) {
      drawerSyncCallbacks.forEach(function (callback) {
        callback(isOpen);
      });
    }

    function bindCartDrawer(cartDrawer) {
      if (!cartDrawer || cartDrawer.dataset.comuStickyDrawerBound === 'true') return false;
      cartDrawer.dataset.comuStickyDrawerBound = 'true';

      if ('MutationObserver' in window) {
        var observer = new MutationObserver(function () {
          notify(cartDrawer.hasAttribute('open'));
        });
        observer.observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
      }

      notify(cartDrawer.hasAttribute('open'));
      return true;
    }

    if (!drawerSyncReady) {
      drawerSyncReady = true;

      document.addEventListener('dialog:after-show', function (event) {
        if (event.target && event.target.id === 'cart-drawer') notify(true);
      });
      document.addEventListener('dialog:after-hide', function (event) {
        if (event.target && event.target.id === 'cart-drawer') notify(false);
      });

      document.addEventListener('shopify:section:load', function (event) {
        var cartDrawer = event.target.querySelector('#cart-drawer') || document.getElementById('cart-drawer');
        if (bindCartDrawer(cartDrawer) && cartDrawer) {
          notify(cartDrawer.hasAttribute('open'));
        }
      });
    }

    bindCartDrawer(document.getElementById('cart-drawer'));
  }

  function initStickyVisibility(root) {
    var hideAtFooter = root.getAttribute('data-hide-at-footer') === 'true';

    /* 「首屏参照物」：只要它还在视口里，就说明用户还没往下滑，吸底栏保持隐藏。
       原来只认 comu-hero 的按钮组——预热页有、商品页没有，
       于是商品页 heroActions 为 null，直接判定「已离开首屏」，一进页面就弹出来。
       这里按优先级依次找：
         1. comu-hero 的按钮组（预热页/首页，行为与以前完全一致）
         2. 商品页购买区的加购按钮（吸底栏本来就是它滚走之后的替身）
         3. 都没有 → 退回滚动阈值（data-show-after 像素） */
    var anchorSelectors = [
      '.shopify-section--comu-hero .hero-actions',
      '[data-comu-hero-actions]',
      '.product-info__buy-buttons',
      '.product-info buy-buttons'
    ];
    var heroActions = null;
    for (var ai = 0; ai < anchorSelectors.length; ai++) {
      heroActions = document.querySelector(anchorSelectors[ai]);
      if (heroActions) break;
    }

    var showAfter = parseInt(root.getAttribute('data-show-after'), 10);
    if (isNaN(showAfter)) showAfter = 0;

    var heroVisible = Boolean(heroActions);
    var footerVisible = false;
    var drawerOpen = false;
    var stickyVisible = null;

    function applyVisibility() {
      var shouldShow = !heroVisible && !footerVisible && !drawerOpen;

      root.classList.toggle('is-hidden-by-drawer', drawerOpen);

      if (stickyVisible !== shouldShow) {
        stickyVisible = shouldShow;

        if (shouldShow) {
          root.classList.remove('is-hidden-by-hero', 'is-hidden-by-footer');
          document.body.classList.add('comu-has-sticky-bar');
        } else {
          root.classList.toggle('is-hidden-by-hero', heroVisible);
          root.classList.toggle('is-hidden-by-footer', !heroVisible && footerVisible);
          /* 抽屉打开时保留 padding-bottom，避免关抽屉时页面跳动 */
          if (!drawerOpen) {
            document.body.classList.remove('comu-has-sticky-bar');
          }
        }
      }
    }

    initDrawerSync(function (isOpen) {
      if (drawerOpen === isOpen) return;
      drawerOpen = isOpen;
      applyVisibility();
    });

    function observeTarget(target, onChange) {
      if (!target) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              onChange(entry.isIntersecting);
            });
          },
          {
            threshold: 0,
            rootMargin: '0px 0px -1px 0px'
          }
        );
        observer.observe(target);
        return;
      }

      function onScroll() {
        var rect = target.getBoundingClientRect();
        onChange(rect.top < window.innerHeight && rect.bottom > 0);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    if (heroActions) {
      /* 判据是「参照物有没有从上方滚走」，不是「参照物可不可见」。
         两者在预热页等价（hero 就在页顶），但在商品页完全不同：
         加购按钮本来就不在首屏，用「可见才隐藏」会得到
         「首屏显示 → 滚到按钮时隐藏 → 滚过又显示」的反向行为。
         rect.bottom > 0 == 参照物底边还没越过视口顶部 == 用户还没滑过它 → 保持隐藏。 */
      var onAnchorScroll = function () {
        var rect = heroActions.getBoundingClientRect();
        var notPassed = rect.bottom > 0;
        if (heroVisible === notPassed) return;
        heroVisible = notPassed;
        applyVisibility();
      };
      window.addEventListener('scroll', onAnchorScroll, { passive: true });
      window.addEventListener('resize', onAnchorScroll);
      onAnchorScroll();
    } else if (showAfter > 0) {
      /* 没有任何参照物时的兜底：滚动超过设定像素才显示 */
      heroVisible = true;
      var onScrollThreshold = function () {
        var past = (window.pageYOffset || document.documentElement.scrollTop) >= showAfter;
        if (heroVisible === !past) return;
        heroVisible = !past;
        applyVisibility();
      };
      window.addEventListener('scroll', onScrollThreshold, { passive: true });
      window.addEventListener('resize', onScrollThreshold);
      onScrollThreshold();
    } else {
      heroVisible = false;
    }

    if (hideAtFooter) {
      var footerTarget = document.querySelector('.shopify-section--footer');
      observeTarget(footerTarget, function (isIntersecting) {
        footerVisible = isIntersecting;
        applyVisibility();
      });
    }

    applyVisibility();
  }

  function initStickyBar(root) {
    if (!root || root.dataset.comuStickyBarReady === 'true') return;

    initStickyVisibility(root);
    root.dataset.comuStickyBarReady = 'true';
  }

  function boot() {
    bindStickyAddToCart();
    document.querySelectorAll('[data-comu-sticky-bar]').forEach(initStickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
